import { apiFetch } from '@/lib/api';
import type { RuntimeSetting, SettingValue } from '@/types/setting';

const S = '/settings';

export const listSettings = () => apiFetch<RuntimeSetting[]>(S);
export const updateSetting = (key: string, value: SettingValue) =>
  apiFetch<RuntimeSetting>(`${S}/${encodeURIComponent(key)}`, {
    method: 'PUT', body: JSON.stringify({ value }),
  });
